import moment from 'moment';
import { useEffect, useRef } from 'react';
import { getAmenityAvailabilityV2 } from '../../../../../redux/actions/bookingParAm';

export function useBookingAvailabilityFetcher({
  watchStartDate,
  watchAmenityId,
  bookingId = null,
  type = null,
  dispatch,
  active = true,
  setVerifyTimeslot
}) {
  const lastAvailabilityKeyRef = useRef(null);

  useEffect(() => {
    if (!active || !watchStartDate || !watchAmenityId) {
      setVerifyTimeslot(false);
      return;
    }

    const amenityIdInt = parseInt(watchAmenityId, 10);
    if (!Number.isFinite(amenityIdInt) || amenityIdInt <= 0) {
      setVerifyTimeslot(false);
      return;
    }

    const startDateStr = moment(watchStartDate).format('YYYY-MM-DD');
    const fetchKey = `${amenityIdInt}-${startDateStr}-${bookingId || 'new'}-${type || 'default'}`;

    if (lastAvailabilityKeyRef.current === fetchKey) return;
    lastAvailabilityKeyRef.current = fetchKey;

    setVerifyTimeslot(false);

    const params = { start_date: startDateStr };
    if (bookingId) params.booking_id = bookingId;
    if (type) params.type = type;

    dispatch(
      getAmenityAvailabilityV2({
        amenity_id: amenityIdInt,
        params
      })
    );
  }, [active, watchStartDate, watchAmenityId, bookingId, type, dispatch, setVerifyTimeslot]);

  return { lastAvailabilityKeyRef };
}
